import { common } from './common'
import { enums } from './enums'
import { shell } from './shell'
import { nav } from './nav'
import { screens } from './screens'
import { merchants } from './merchants'
import { discovery } from './discovery'
import { webscan } from './webscan'
import { brands } from './brands'
import { rules } from './rules'
import { admin } from './admin'
import { triage } from './triage'
import { ads } from './ads'
import { betting } from './betting'
import { guide } from './guide'

/**
 * Catalogue complet.
 *
 * Les bundles sont fusionnés à plat : une clé porte son domaine en préfixe
 * (`merchants.`, `ads.`…), ce qui évite les collisions sans imbrication.
 */
export const MESSAGES = {
  ...common,
  ...enums,
  ...shell,
  ...nav,
  ...screens,
  ...merchants,
  ...discovery,
  ...webscan,
  ...brands,
  ...rules,
  ...admin,
  ...triage,
  ...ads,
  ...betting,
  ...guide,
}

export type MessageKey = keyof typeof MESSAGES
